/**
 * Reorders an array by moving an item from one index to another
 * @param list - The array to reorder
 * @param fromIndex - The index to move from
 * @param toIndex - The index to move to
 * @returns A new array with the items reordered
 */
export function reorderArray<T>(list: T[], fromIndex: number, toIndex: number): T[] {
  const result = Array.from(list)
  const [removed] = result.splice(fromIndex, 1)
  result.splice(toIndex, 0, removed)
  return result
}
